import axios from '@axios'

const route = 'calendar/schedule_customer'

export default {
  namespaced: true,
  state: {
    company: null,
    step: 1,
    services:[],
    schedule: {},
    confirmation: {},
    scheduleReserved:{},
    snackbar_text: '',
    snackbar: false,
  },
  getters: {
    getStep(state){
      return state.step
    },

    getServices(state){
      return state.services
    },
    getSchedule(state){
      return state.schedule
    },
    getDate(state){
      return state.schedule.date
    },
    getTime(state){
      return state.schedule.time
    },
    getCompany(state){
      return state.company
    },
    getConfirmation(state){
      return state.confirmation
    },
    getScheduleReserved(state){
      return state.scheduleReserved
    },
    getSnackbar(state){
      return state.snackbar
    },
    getSnackbarText(state){
      return state.snackbar_text
    }


  },
  mutations: {
    setStep(state, step){
      state.step = step
    },
    setServices(state, services){
      state.services = services
    },
    setService(state, service){
      state.schedule.service = service
      state.schedule.service_id = service.id
    },
    setHash(state, hash){
      state.schedule.hash = hash
    },
    setDate(state, date){
      state.schedule.date = date
    },
    setTime(state, time){
      state.schedule.time = time
    },
    setCompany(state, company){
      state.company = company
    },
    setConfirmation(state, confirmation){
      state.confirmation = confirmation
    },
    setScheduleReserved(state, schedule){
      state.scheduleReserved = schedule
    },
    setSnackbar(state, snackbar){
      state.snackbar = snackbar
    },
    setSnackbarText(state, text){
      state.snackbar_text = text
    }

  },
  actions: {
    index(context,{scheduleCustomerData, hash}){
      return axios.post(`${route}/index?hash=${hash}`, {schedule_customer_data: scheduleCustomerData})
    },

    loadServices(context,schedule ){
      return axios.get(`${route}/services?hash=${schedule.hash}`)
    },

    loadDates(context, schedule){
      let data = {
        service_id: schedule.service_id,
        hash: schedule.hash
      }
      return axios.post(`${route}/dates_available`, data)
    },

    loadTimes(context, schedule){
      let data = {
        service_id: schedule.service_id,
        date: schedule.date,
        hash: schedule.hash
      }
      return axios.post(`${route}/times_available`, data)
    },

    //salvar o agendamento
    saveSchedule(context, schedule){
      return axios.post(`${route}/save`, schedule)
    },
    cancelSchedule(context, schedule){
      return axios.post(`${route}/cancel`, schedule)
    },
    confirmSchedule(context, schedule){
      return axios.post(`${route}/confirm`, schedule)
    },

    // loadCompany(context, hash){
    //   return axios.get(`${route}/company?hash=${hash}`)
    // }
  },
}
